// extracted by mini-css-extract-plugin
export default {"canvasContainer":"PhotoPage_canvasContainer__YdDNZ","canvasContainerContainer":"PhotoPage_canvasContainerContainer__xtpgT","main":"PhotoPage_main__+O5r5"};